import * as React from "react";

function BuildingColumnsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M494.4 128.1c10.9 6 17.6 17.4 17.6 29.8 0 18.9-15.2 34.1-34.1 34.1H34.06C15.25 192 0 176.8 0 157.9c0-12.4 6.745-23.8 17.61-29.8L244.4 2.986c7.2-3.981 16-3.981 23.2 0L494.4 128.1zM224 128c0-17.7 14.3-32 32-32s32 14.3 32 32c0 5.8-1.6 11.3-4.3 16h140.1L256 51.41 88.18 144H228.3c-2.7-4.7-4.3-10.2-4.3-16zM64 224h48v160h64V224h48v160h64V224h48v160h64V224h48v160h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H64c-13.25 0-24-10.7-24-24s10.75-24 24-24V224zm424 240c13.3 0 24 10.7 24 24s-10.7 24-24 24H32c-13.25 0-24-10.7-24-24s10.75-24 24-24h456z"
  }));
}

const ForwardRef = React.forwardRef(BuildingColumnsIcon);
export default ForwardRef;